module.exports = __webpack_public_path__ + "media/hyper/images/logo-dark-7f777829807a56f27f78b8ff80f9df4c.png";